import React from "react"
import lodash from "lodash"

import TooltipTrigger from '../../../../../1stlog-ui/src/components/TooltipTrigger'

export const countryOptionsEurope = [
  {
    label: "Belgien",
    value: "BE"
  },
  {
    label: "Dänemark",
    value: "DK"
  },
  {
    label: "Deutschland",
    value: "DE"
  },
  {
    label: "Frankreich",
    value: "FR"
  },
  {
    label: "Italien",
    value: "IT"
  },
  {
    value: "LI",
    label: "Fürstentum Liechtenstein"
  },
  {
    label: "Luxemburg",
    value: "LU"
  },
  {
    label: "Niederlande",
    value: "NL"
  },
  {
    label: "Österreich",
    value: "AT"
  },
  {
    label: "Polen",
    value: "PL"
  },
  {
    label: "Schweiz",
    value: "CH"
  },
  {
    label: "Spanien",
    value: "ES"
  },
  {
    label: "Tschechien",
    value: "CZ"
  },
  {
    label: "Vereinigtes Königreich",
    value: "GB"
  }
]

export const countryOptionsInternational = [
  {
    label: "China",
    value: "CN"
  },
  {
    label: "USA",
    value: "US"
  }
]

function getIcon(shortcode) {
  const value = lodash.lowerCase(shortcode)
  switch (value) {
    case "en":
      return "gb"
    default:
      return value
  }
}

export default props => {
  const { code } = props
  const country = getIcon(code)
  return (
    <TooltipTrigger useReactstrap element={null}>
      <span>
        <i className={`flag-icon flag-icon-${country}`} />{" "}
        <b>{country.toUpperCase()}</b>
      </span>
    </TooltipTrigger>
  )
}
